import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { browserName, deviceType } from 'react-device-detect';
import { useLocation } from 'react-router';
import { useAuth } from '../context/auth/hooks';

export const LDUserLocation = () => {
  const location = useLocation();
  const client = useLDClient();
  const { isLoggedIn } = useAuth();
  const segmentUserId =
    // eslint-disable-next-line react-x/purity -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
    localStorage.getItem('ajs_anonymous_id')?.replaceAll('"', '') ||
    // eslint-disable-next-line react-x/purity -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
    localStorage.getItem('ajs_user_id')?.replaceAll('"', '') ||
    '';

  // update LaunchDarkly user attributes when location changes
  useEffect(() => {
    if (client) {
      const currentUserKey = sessionStorage.getItem('USER_ID');
      const userPayload = {
        location: window.location.href,
        browserName: browserName,
        deviceType: deviceType,
        province: localStorage.getItem('PROVINCE') || '',
        hasReceivedRX: sessionStorage.getItem('HAS_RECEIVED_RX') || '',
        segmentId: segmentUserId,
      };

      const existingCustom = client.getContext().custom;

      if (isLoggedIn && currentUserKey) {
        const updatedUser = {
          key: currentUserKey,
          custom: { ...existingCustom, ...userPayload },
        };
        client.identify(updatedUser);
      } else {
        const updatedUser = client.getContext();
        updatedUser.custom = { ...existingCustom, ...userPayload };
        client.identify(updatedUser);
      }
    }
  }, [client, location, isLoggedIn, segmentUserId]);

  return null;
};
